module.exports = __webpack_public_path__ + "static/media/225600_2006772455680_7231249_n.5c74b547.jpg";